export default "__VITE_ASSET__D_wRzc09__"